import { render, staticRenderFns } from "./MyChannels.vue?vue&type=template&id=3abe0aad&scoped=true"
import script from "./MyChannels.vue?vue&type=script&lang=js"
export * from "./MyChannels.vue?vue&type=script&lang=js"
import style0 from "./MyChannels.vue?vue&type=style&index=0&id=3abe0aad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abe0aad",
  null
  
)

export default component.exports